// @generated by protoc-gen-es v2.2.2 with parameter "target=ts"
// @generated from file ga/config_manager/currency/currency.proto (package ga.config_manager.currency, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file ga/config_manager/currency/currency.proto.
 */
export const file_ga_config_manager_currency_currency: GenFile = /*@__PURE__*/
  fileDesc("CilnYS9jb25maWdfbWFuYWdlci9jdXJyZW5jeS9jdXJyZW5jeS5wcm90bxIaZ2EuY29uZmlnX21hbmFnZXIuY3VycmVuY3kiDQoLTGlzdFJlcXVlc3QimwIKDExpc3RSZXNwb25zZRISCgpjdXJyZW5jaWVzGAEgAygJElUKD2N1cnJlbmNpZXNfaW5mbxgCIAMoCzI8LmdhLmNvbmZpZ19tYW5hZ2VyLmN1cnJlbmN5Lkxpc3RSZXNwb25zZS5DdXJyZW5jaWVzSW5mb0VudHJ5GjIKDEN1cnJlbmN5SW5mbxIQCghzdWJ1bml0cxgBIAEoAxIQCghkZWNpbWFscxgCIAEoAxpsChNDdXJyZW5jaWVzSW5mb0VudHJ5EgsKA2tleRgBIAEoCRJECgV2YWx1ZRgCIAEoCzI1LmdhLmNvbmZpZ19tYW5hZ2VyLmN1cnJlbmN5Lkxpc3RSZXNwb25zZS5DdXJyZW5jeUluZm86AjgBMmwKD0N1cnJlbmN5U2VydmljZRJZCgRMaXN0EicuZ2EuY29uZmlnX21hbmFnZXIuY3VycmVuY3kuTGlzdFJlcXVlc3QaKC5nYS5jb25maWdfbWFuYWdlci5jdXJyZW5jeS5MaXN0UmVzcG9uc2VCgAIKHmNvbS5nYS5jb25maWdfbWFuYWdlci5jdXJyZW5jeUINQ3VycmVuY3lQcm90b1ABWkl4ZGV2dGVhbS5jb20vYThyL2NvbmZpZy1tYW5hZ2VyL2ludGVybmFsL3Byb3RvL2dhL2NvbmZpZ19tYW5hZ2VyL2N1cnJlbmN5ogIDR0NDqgIZR2EuQ29uZmlnTWFuYWdlci5DdXJyZW5jecoCGUdhXENvbmZpZ01hbmFnZXJcQ3VycmVuY3niAiVHYVxDb25maWdNYW5hZ2VyXEN1cnJlbmN5XEdQQk1ldGFkYXRh6gIbR2E6OkNvbmZpZ01hbmFnZXI6OkN1cnJlbmN5YgZwcm90bzM");

/**
 * @generated from message ga.config_manager.currency.ListRequest
 */
export type ListRequest = Message<"ga.config_manager.currency.ListRequest"> & {
};

/**
 * Describes the message ga.config_manager.currency.ListRequest.
 * Use `create(ListRequestSchema)` to create a new message.
 */
export const ListRequestSchema: GenMessage<ListRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_currency_currency, 0);

/**
 * @generated from message ga.config_manager.currency.ListResponse
 */
export type ListResponse = Message<"ga.config_manager.currency.ListResponse"> & {
  /**
   * @generated from field: repeated string currencies = 1;
   */
  currencies: string[];

  /**
   * @generated from field: map<string, ga.config_manager.currency.ListResponse.CurrencyInfo> currencies_info = 2;
   */
  currenciesInfo: { [key: string]: ListResponse_CurrencyInfo };
};

/**
 * Describes the message ga.config_manager.currency.ListResponse.
 * Use `create(ListResponseSchema)` to create a new message.
 */
export const ListResponseSchema: GenMessage<ListResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_currency_currency, 1);

/**
 * @generated from message ga.config_manager.currency.ListResponse.CurrencyInfo
 */
export type ListResponse_CurrencyInfo = Message<"ga.config_manager.currency.ListResponse.CurrencyInfo"> & {
  /**
   * @generated from field: int64 subunits = 1;
   */
  subunits: bigint;

  /**
   * Equal to `lg(subunits)`
   *
   * @generated from field: int64 decimals = 2;
   */
  decimals: bigint;
};

/**
 * Describes the message ga.config_manager.currency.ListResponse.CurrencyInfo.
 * Use `create(ListResponse_CurrencyInfoSchema)` to create a new message.
 */
export const ListResponse_CurrencyInfoSchema: GenMessage<ListResponse_CurrencyInfo> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_currency_currency, 1, 0);

/**
 * @generated from service ga.config_manager.currency.CurrencyService
 */
export const CurrencyService: GenService<{
  /**
   * @generated from rpc ga.config_manager.currency.CurrencyService.List
   */
  list: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_ga_config_manager_currency_currency, 0);

